// extracted by mini-css-extract-plugin
export default {"main":"orderpage_main__OoYwm"};